export default __webpack_public_path__ + "static/media/u111.60b25114.png";